import { Layout } from '../../../components/Layout'
import { HeadingPages } from '../../../components/HeadingPages'
import { Button, Flex, Input, Select, Table, TableContainer, Tbody, Th, Thead, Tr } from '@chakra-ui/react'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { useEffect, useState } from 'react'
import Axios from 'axios'
import { Item } from './Item'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api/index'
import { useMutation } from 'react-query'
import { formatPrice } from '../../../utils/formatPrice'
import { useCustomers } from '../../../hooks/useCustomers'
import { useExcelGenerator } from '../../../hooks/useExcelGenerator'
import { useSearchParams } from 'react-router-dom'
import { format } from 'date-fns'

async function getFechamentoFrete({ numinno, numnota, empresa, vendedor, data_entrada, data_saida, validacao }) {
  try {
    const response = await api.post('/site/v2/controle-crm/controle-fechamento-frete', {
      numinno,
      numnota,
      codigo_empresa: empresa,
      codigo_vendedor: vendedor,
      data_entrada,
      data_saida,
      validacao,
    })

    return response.data.map((item) => {
      const multiplicador = 1.3

      const labels = {
        'INNOVATION COMERCIO DE BRINDES': 'INNOVATION',
        'D & T COMERCIO DE BRINDES EIRELI': 'DT',
      }

      const transportadoras = {
        'Transportadora Cliente': 'TRANSP. CLIENTE',
      }

      return {
        ...item,
        nome_empresa: labels[item.nome_empresa] || item.nome_empresa,
        nome_vendedor: item.nome_vendedor?.toUpperCase(),
        vlr_frete: formatPrice(item.vlr_frete),
        valor_real_frete: formatPrice(item.valor_real_frete),
        frete30: formatPrice(item.valor_real_frete * multiplicador),
        frete_over: formatPrice(item.frete_over),
        transportadora: transportadoras[item.transportadora] || item.transportadora,
        nfe: item.nfe || 'Sem NFE',
        //dt_frete com dia mes e hora
        dia_mes_dt_frete: item.dt_frete ? format(new Date(item.dt_frete), 'dd/MM/yyyy') : '',
        hora_dt_frete: item.dt_frete ? format(new Date(item.dt_frete), 'HH:mm') : '',
      }
    })
  } catch (error) {
    console.log(error)
  }
}

export function FechamentoFrete() {
  const { height } = useWindowSize()

  const { customers, enterprise } = useCustomers()

  const { mutateAsync, isLoading, isError, data } = useMutation((data) => getFechamentoFrete(data))

  const [dataSearch, setDataSearch] = useSearchParams()

  const { handleSubmit, register, formState, setValue } = useForm({
    defaultValues: {
      inno: dataSearch.get('inno') || '',
      nota: dataSearch.get('nota') || '',
      empresa: dataSearch.get('empresa') || '',
      vendedor: dataSearch.get('vendedor') || '',
      data_entrada: dataSearch.get('data_entrada') || '',
      data_saida: dataSearch.get('data_saida') || '',
      validacao: dataSearch.get('validacao') || '',
    },
  })

  useEffect(() => {
    setValue('inno', dataSearch.get('inno') || '')
    setValue('nota', dataSearch.get('nota') || '')
    setValue('empresa', dataSearch.get('empresa') || '')
    setValue('vendedor', dataSearch.get('vendedor') || '')
    setValue('data_entrada', dataSearch.get('data_entrada') || '')
    setValue('data_saida', dataSearch.get('data_saida') || '')
    setValue('validacao', dataSearch.get('validacao') || '')
  }, [dataSearch])

  const { generateExcel, loading } = useExcelGenerator()

  const handleGenerateExcel = () => {
    const header = [
      'Nº Unico',
      'Nº Inno',
      'NFE',
      'Data',
      'Empresa',
      'Vendedor',
      'Vlr Frete',
      'Vlr Real Frete',
      'Frete + 30%',
      'Frete Over',
      'Transportadora',
      'Validação Financeiro',
      'Validação Rodrigo',
    ]

    const dataItems = data?.map((item) => {
      return {
        nota: item.nunota,
        inno: item.numinno,
        nfe: item.nfe || 'Sem NFE',
        data: item.dia_mes_dt_frete + ' ' + item.hora_dt_frete,
        empresa: item.nome_empresa,
        vendedor: item.nome_vendedor,
        vlrFrete: item.vlr_frete,
        vlrRealFrete: item.valor_real_frete,
        frete30: item.frete30,
        freteOver: item.frete_over,
        transportadora: item.transportadora,
        validacaoFinanceiro: item.valida_financeiro === 'S' ? 'Sim' : 'Não',
        validacaoRodrigo: item.valida_rodrigo === 'S' ? 'Sim' : 'Não',
      }
    })

    generateExcel(header, dataItems, 'FechamentoFrete')
  }

  const handleFilterData = async (data) => {
    const { inno, nota, empresa, vendedor, validacao } = data

    setDataSearch(data)

    mutateAsync({
      numinno: inno,
      numnota: nota,
      empresa: empresa,
      vendedor: vendedor,
      data_entrada: data.data_entrada,
      data_saida: data.data_saida,
      validacao: validacao,
    })
  }

  console.log(dataSearch.get('data_entrada'))

  async function refresh() {
    await mutateAsync({
      numinno: dataSearch.get('inno') || '',
      numnota: dataSearch.get('nota') || '',
      empresa: dataSearch.get('empresa') || '',
      vendedor: dataSearch.get('vendedor') || '',
      data_entrada: dataSearch.get('data_entrada') || '',
      data_saida: dataSearch.get('data_saida') || '',
      validacao: dataSearch.get('validacao') || '',
    })
  }

  //chamar o endpoint assim que entrar na tela
  useEffect(() => {
    mutateAsync({
      numinno: dataSearch.get('inno') || '',
      numnota: dataSearch.get('nota') || '',
      empresa: dataSearch.get('empresa') || '',
      vendedor: dataSearch.get('vendedor') || '',
      data_entrada: dataSearch.get('data_entrada') || '',
      data_saida: dataSearch.get('data_saida') || '',
      validacao: dataSearch.get('validacao') || '',
    })
  }, [])

  console.log(data)

  return (
    <>
      <HeadingPages name="Fechamento de Frete" />
      <Layout>
        <Flex gap={2} mb={4} as="form" onSubmit={handleSubmit(handleFilterData)}>
          <Input placeholder="Nº Inno" {...register('inno')} />
          <Input placeholder="Nº Unico" {...register('nota')} />
          <Input type="date" {...register('data_entrada')} />
          <Input type="date" {...register('data_saida')} />
          <Select placeholder="Empresa" {...register('empresa')}>
            {enterprise?.map((empresa) => (
              <option key={empresa.codigo_empresa} value={empresa.codigo_empresa}>
                {empresa.nome_empresa}
              </option>
            ))}
          </Select>
          <Select placeholder="Vendedor" {...register('vendedor')}>
            {customers?.map((vendedor) => (
              <option key={vendedor.codvend} value={vendedor.codvend}>
                {vendedor.apelido}
              </option>
            ))}
          </Select>

          <Select placeholder="Validação" {...register('validacao')}>
            <option value="">Todos</option>
            <option value="F">Validado Financeiro</option>
            {/* <option value="R">Validado Rodrigo</option> */}
            <option value="L">Liberado</option>
          </Select>

          <Button
            backgroundColor="green.500"
            color="white"
            _hover={{
              filter: 'brightness(0.9)',
            }}
            maxW="200px"
            w="full"
            type="submit"
            isLoading={isLoading}
            loadingText="Buscando"
          >
            Buscar
          </Button>
        </Flex>
        <Button
          onClick={handleGenerateExcel}
          backgroundColor="green.500"
          color="white"
          _hover={{
            filter: 'brightness(0.9)',
          }}
          isLoading={loading}
          maxW="200px"
          w="full"
          loadingText="Gerando excel"
        >
          Gerar Excel
        </Button>
        <TableContainer w="100%" maxH={height - 400} overflowY="auto" mt="4">
          <Table colorScheme="blue">
            <Thead
              style={{
                backgroundColor: '#F5F8FA',
                fontWeight: 'bold',
                fontSize: '14px',
                lineHeight: '16px',
                color: '#47585B',
                borderRadius: '8px',
              }}
              boxShadow="md"
              position="sticky"
              top="0"
              zIndex="1"
            >
              <Tr>
                <Th>Nº Unico</Th>
                <Th>Nº Inno</Th>
                <Th>NFE</Th>
                <Th>Data</Th>
                <Th>Empresa</Th>
                <Th>Vendedor</Th>
                <Th>Vlr Frete</Th>
                <Th>Vlr Real Frete</Th>
                <Th>Frete + 30%</Th>
                <Th>Frete Over</Th>
                <Th>Transportadora</Th>
                <Th>Val. Finan</Th>
                <Th>Val. Rodrigo</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data?.map((item, index) => (
                <Item key={index} item={item} refresh={() => refresh()} />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Layout>
    </>
  )
}
